import React, {Component} from 'react'
import PropTypes from 'prop-types'
import TableHeadBoxItems from "./TableHeadBoxItems"
import RowBoxItemContainer from "./RowBoxItemContainer";
import {Spin} from "antd";



class ListBoxItems extends Component {
    state = {
        arrSelected: [],
        selectAll: false,
    }

    _handleCheckAll = (isChecked) => {
        this.setState(() => {
            if (isChecked) {
                const {items} = this.props
                const itemIds = items.map(item => ({
                    id: item._id,
                    barcode: (!!item && !!item.item_number && !!item.item_index) ? `${item.item_number}_${item.item_index}` : ''
                }))

                return {
                    arrSelected: itemIds,
                    selectAll: true,
                }
            }

            return {
                arrSelected: [],
                selectAll: false,
            }
        })
    }

    _updateSelectedBox = (item, isAdded) => {
        const {_id : id, item_number, item_index} = Object.assign({}, item)
        this.setState(({arrSelected}) => {
            if (isAdded && !arrSelected.some(i => i.id === id)) {
                return {
                    arrSelected: [...arrSelected, {
                        id,
                        barcode: (!!item_number && !!item_index) ? `${item_number}_${item_index}` : ''
                    }],
                    selectAll: arrSelected.length + 1 === this.props.items.length,
                }
            } else {
                const filtered = arrSelected.filter(item => item.id !== id)

                return {
                    arrSelected: filtered,
                    selectAll: false,
                }
            }
        })
    }

    render() {
        const {items, isPrivate, onRefresh, box, loading, isAdmin, showDelete, handleCheckDelete} = this.props
        const {selectAll, arrSelected} = this.state

        return (
            <div className="ListBoxItems mt-3">
                <table className="table">
                    <TableHeadBoxItems
                        isAdmin={isAdmin}
                        showDelete={showDelete}
                        handleCheckDelete={handleCheckDelete}
                        onCheckAll={this._handleCheckAll}
                        selectAll={selectAll}
                        arrSelected={arrSelected}
                        onRefresh={onRefresh}
                        box={box}
                    />
                    {
                        loading ? '' : 
                        <RowBoxItemContainer 
                            items={items} 
                            onRefresh={onRefresh} 
                            isPrivate={isPrivate} 
                            box={box} 
                            showDelete={showDelete}
                            onSelected={this._updateSelectedBox}
                            arrSelected={arrSelected}
                            onCheckAll={this._handleCheckAll}
                        />
                    }
                </table>

                {
                    loading ? <Spin spinning={loading} tip='Đang tải...' className='next-boxes-loading'/> : ''
                }
            </div>
        )
    }
}

ListBoxItems.propTypes = {
    box: PropTypes.object.isRequired,
    items: PropTypes.array.isRequired,
    onRefresh: PropTypes.func.isRequired,
    isPrivate: PropTypes.bool.isRequired,
}

export default ListBoxItems
